var _G, _Circle, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Circle, Defs, Mask } from "react-native-svg";
function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M4.667 7L7 4.667 9.333 7M7 4.667v4.666"
  }))), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    mask: "url(#arrow-up_svg__inner-circle)",
    cx: 7,
    cy: 7,
    r: 6.333,
    fill: "#F7F7F7"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-up_svg__inner-circle"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 7,
    cy: 7,
    r: 5.333,
    fill: "#000"
  })))));
}
export default SvgArrowUp;